import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

function Notification() {
	return <ToastContainer autoClose={2000} hideProgressBar closeButton={false} style={{ zIndex: 999999 }} />;
}

export default Notification;
